import React, { useState, useEffect } from "react";
import { Form, Input, Button, Checkbox,Spin,notification } from "antd";
import axios from "axios";
import { path, src } from "../network/conn";
import { SmileOutlined } from "@ant-design/icons";
import "antd/dist/antd.css";
import "../css/login.css";
import { useNavigate } from "react-router-dom";
const Login = () => {
  const navigate = useNavigate();
  const [username, setusername]     = useState("");
  const [password, setpassword]     = useState("");
  const [dataSource, setdataSource] = useState([]);
  const [spinner,setSpinner]        = useState(true);

  const openQuanNotification = () => {
    notification.open({
      message: "Error",
      description: "Username Or Password is Incorrect",
      icon: <SmileOutlined style={{ color: "#108ee9", color: "red" }} />,
    });
  };  

  const onFinish = () => {
    console.log('datasource',dataSource);
    let filterData  = dataSource.find((list)=>{return list.username == username && list.password == password});
    if(filterData){
      window.sessionStorage.setItem("user", username);
      window.sessionStorage.setItem("profile",filterData.usertype);
      navigate("/navbar/dashboard");
    }else{
      openQuanNotification()
    }
  };
  const fetchEmployeelist = () => {
   // setLoading(true);
    let BaseURL = path + src + "employeelist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setdataSource(response.data);
      })
      .catch((error) => {
       // openMessageSuccess(error, 10);
      });
  };
  const feildUser = (e) => { 
    setusername(e.target.value);
  };
  const feildPass = (e) => {
    setpassword(e.target.value);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  setTimeout(()=>{setSpinner(false)
},1000);
  useEffect(() => {
    fetchEmployeelist();
  }, []);

  return (
   <>
    {!spinner ? 
    <div className="loginContent">
      <div className="loginValue">
        <h1>Login</h1>
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Please input your username!" }]}
            value={username}
          >
            <Input onChange={feildUser} />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
            value={password}
          >
            <Input.Password onChange={feildPass} />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>Remember me</Checkbox>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div> : <div class="spinnerClass"><Spin tip="Loading..." size="large"></Spin></div>}
    </>);
};
export default Login;
